import React, { Fragment } from 'react';
import { useMultilingualText } from 'features/hooks';

const MultilingualText = ({ tKey, area }) => {

  const text = useMultilingualText(tKey, area)

  return <Fragment>{text}</Fragment>
}
export default MultilingualText;